import type React from "react";
import type { Book } from "../../../app/books";

import { BookOpen } from "lucide-react";
import { useTranslation } from "react-i18next";

type BookDetailsProps = {
  book: Book;
};

export const BookDetails: React.FC<BookDetailsProps> = ({ book }) => {
  const { t } = useTranslation();

  return (
    <div className="dui-card bg-base-200 shadow-xl">
      <div className="dui-card-body">
        <h2 className="dui-card-title mb-4 flex items-center gap-2">
          <BookOpen className="h-5 w-5" />
          {t("book.details.title")}
        </h2>
        <div className="space-y-3">
          {book.publishers && (
            <div className="flex justify-between">
              <span className="font-medium">{t("book.details.publisher")}</span>
              {(book.publishers ?? []).map((publisher) => (
                <span key={publisher}>{publisher}</span>
              ))}
            </div>
          )}

          {book.publicationDate && (
            <div className="flex justify-between">
              <span className="font-medium">{t("book.details.publicationDate")}</span>
              <span>{book.publicationDate}</span>
            </div>
          )}

          <div className="flex justify-between">
            <span className="font-medium">{t("book.details.isbn")}</span>
            <span className="flex gap-3 font-mono text-sm">
              {(book.isbn ?? []).map((isbn) => (
                <span key={isbn}>{isbn}</span>
              ))}
            </span>
          </div>

          {book.numberOfPages && (
            <div className="flex justify-between">
              <span className="font-medium">{t("book.details.numberOfPages")}</span>
              <span>{book.numberOfPages}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
